export const enum ORDER_STATE_ID {
    Pending = 0,
    Expired = 1,
    Canceled = 2,
    Paid = 3
}
